
        var result = require("!!../../../../../node_modules/css-loader/index.js!./us.component.css");

        if (typeof result === "string") {
            module.exports = result;
        } else {
            module.exports = result.toString();
        }
    